import { COMEINURL, ESIGN_URL, IRMURL } from './host';

export const common = {
	linkConvert: IRMURL + '/open/irm/common/url/get'
};

// 路演、调研、线上+线上活动、报名 接口
export const activity = {
	// 活动详情
	detail: 'json_meetingactivity_detail',
	conferenceInfo: IRMURL + '/irm/conference/h5/conference-info', // irm活动页详情
	conferenceDetail: IRMURL + '/irm/conference/h5/conference-detail', // irm活动页详情
	registerInfo: IRMURL + '/irm/conference/h5/register-info', // 获取当前用户报名信息
	checkInfo: IRMURL + '/irm/conference/h5/checkin-info', // 获取用户签到信息
	register: IRMURL + '/irm/conference/h5/register', // 提交报名
	autoRegister: IRMURL + '/open/irm/conference/h5/auto-login/register', // 提交报名
	lastRegisterInfo: IRMURL + '/irm/conference/h5/last-register-info', // 上次报名信息
	getCompanyName: IRMURL + '/irm/institution/get-names', // 名称匹配机构
	checkin: IRMURL + '/irm/conference/h5/checkin',
	postQuestion: IRMURL + '/irm/conference/online/pre-question-commit',
	getQuestionHistory: IRMURL + '/irm/conference/register/detail-question',
	getQuestionList: IRMURL + '/irm/pre-question/list',
	addQuestion: IRMURL + '/irm/pre-question/add',
	// 代随行人员参会报名
	entourageRegister: `${IRMURL}/irm/entourage/info/register`,
	// conference-type/list
	conferenceTypeList: `${IRMURL}/irm/conference-type/list`,
	checkShareKey: key => `${IRMURL}/irm/conference/mobile/checkShareKey/${key}`,
	registerCertificate: IRMURL + '/irm/conference/h5/register-certificate'
};

// 会议相关接口
export const conference = {
	getMonitorList: IRMURL + '/open/irm/conference/offline/monitor-list',
	getMonitorSummary: IRMURL + '/open/irm/conference/offline/monitor-detail',
	monitorCheckin: IRMURL + '/irm/conference/offline/monitor-checkin',
	getofflineMonitorDetail: IRMURL + '/irm/conference/offline/detail',
	offlineDetail: IRMURL + '/irm/conference/offline/detail',
	getPosterInfo: IRMURL + '/open/irm/conference/h5/poster-info',
	emailNotify: IRMURL + '/open/irm/conference/h5/auto-login/email-notify',
	getInstitutionUserInfo: IRMURL + '/irm/conference/h5/institution-user-info'
};

export const roadshow = {
	// 获取路演权限
	permission: 'json_event_noticepageauth',
	// 获取路演状态
	status: 'json_event_noticepagestatus'
};

export const login = {
	phonelogin: 'json_user_phonelogin',
	pwdlogin: 'json_user_weblogin',
	// 行为验证码获取 appid 等信息
	getAuthAppid: 'json_captcha_get-auth-info'
};

export const register = {
	// 获取验证码
	phoneauth: 'json_user_getphoneauth',
	// 获取邮箱验证码+校验验证码
	emailauth: 'json_user_email-regist',
	// 校验验证码
	checkPhoneauth: 'json_user_checkauth',
	// 昵称重名校验
	unamecheck: 'json_user_unamecheck',
	// 违规词汇校验
	getbyword: 'json_sensitive_getbyword',
	// 注册账号
	accountPhone: 'json_user_register',
	accountEmail: 'json_user_email-regist-final',
	// 绑定手机号
	boundPhone: 'json_user_bound',
	// 邮箱忘记密码时获取验证码+校验验证码+重置密码
	emailPassword: 'json_account_find-password-by-email',
	// 手机忘记密码时获取验证码
	checkphoneauth: 'json_user_checkphoneauth',
	// 重置密码-手机号
	resetPassword: 'json_user_resetPassword'
};
export const apply = {
	// 申请开通
	apiApplyAnalysis: IRMURL + '/open/apply-for-permission'
};

export const eVisaTask = {
	// 获取任务列表
	taskList: ESIGN_URL + '/esign/task/v3/signer/detail',
	// 表决保存
	saveVote: ESIGN_URL + '/esign/task/v3/signer/save-vote',
	voteSign: ESIGN_URL + '/esign/task/v3/signer/vote-sign',
	getBatchUrl: ESIGN_URL + '/esign/task/v3/signer/get-batch-url',
	signerFlow: ESIGN_URL + '/esign/task/v3/signer/flow',
	signedFileUrl: id => ESIGN_URL + `/esign/internal/sign-flow/oss-url/${id}`,
	accessExternalService: `${COMEINURL}/usercenter/json/auth/accessExternalService`,
	// 预览
	previewSignDetail: ESIGN_URL + '/esign/public/task/preview/signer/detail',
	previewSignFlow: ESIGN_URL + '/esign/public/task/preview/signer/flow',
	previewSaveVote: ESIGN_URL + '/esign/public/task/preview/signer/save-vote',
	previewSaveSign: ESIGN_URL + '/esign/public/task/preview/signer/sign',
	getSignFileList: ESIGN_URL + '/esign/public/task/preview/signer/sign-file-list',
	getOssSignature: `${COMEINURL}/platform/json/oss/signature`
};

export const graphicSummary = {
	// 获取模板详情
	graphicInfo: (companyId, id) => `${IRMURL}/anonymous/irm/long/image/${companyId}/detailInfo/${id}`,
	companyInfo: companyId => `${IRMURL}/anonymous/irm/long/image/${companyId}/report/theme`
};

export const appointment = {
	//根据ID获取会议模版数据
	templatebaseInfo: (companyId, id) => `${IRMURL}/irm/conference/template/${companyId}/baseInfo/${id}`,
	// 获取可选时间点 http://yapi.comein.cn/project/56/interface/api/50153
	getOptionalTime: conferenceTemplateId => `${IRMURL}/irm/invitation/card/${conferenceTemplateId}/optionalDate`,
	// 锁定时间点 http://yapi.comein.cn/project/56/interface/api/50126
	lockTime: conferenceTemplateId => `${IRMURL}/irm/invitation/card/${conferenceTemplateId}/lockDate`,
	unlockTime: conferenceTemplateId => `${IRMURL}/irm/invitation/card/${conferenceTemplateId}/unlockDate`,
	//投资人根据邀约卡预约活动
	createConference: conferenceTemplateId => `${IRMURL}/irm/invitation/card/${conferenceTemplateId}/create/conference`,
	// 获取海报模板配置
	posterConfig: `${IRMURL}/irm/file-template/info`,
	//随行人员列表
	entourageList: `${IRMURL}/irm/invitation/card/entourage/info/list`,
	// 所有股东列表
	allInstitutionList: COMEINURL + '/usercenter/manage/institution/list'
};

// 企业号
export const irstore = {
	getMenuData: (storeId, pageId) => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/page/${pageId}`,
	getPageSaveContent: (storeId, pageId) => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/innerPage/${pageId}`,
	getBaseInfo: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}`,
	getIrstoreInfo: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/info`,
	getNewsList: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/news`,
	postReportList: `${COMEINURL}/irmcenter/anonymous/irstore/report/list`,
	postAdvisoryList: `${COMEINURL}/irmcenter/anonymous/irm/store/advisory/list`,
	getAnnouncements: id => `${COMEINURL}/irmcenter/v2/anonymous/irstore/${id}/announcements`,
	postAllActivityList: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/clearance-activity/list`,
	getCustomModuleContent: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/moduleContent`,
	fetchStoreSubscription: 'json_irstore_subscribe', // 关注企业号
	getPerformance: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/quarter/performance`,
	getRoadshowList: id => `${COMEINURL}/irmcenter/anonymous/irstore/${id}/roadshow`,
	getActivityList: id => `${COMEINURL}/irmcenter/anonymous/irstore/${id}/activity`,
	getSummaryList: id => `${COMEINURL}/irmcenter/anonymous/irstore/${id}/summary`, // 调研纪要
	getStockQuote: (market, code) => `${COMEINURL}/irmcenter/anonymous/irstore/market/${market}/code/${code}/quote`,
	getSseStockQuotation: `${COMEINURL}/irmcenter/open/store/sse-stock-quotation`, //股票实时查询
	createLeaveWord: id => `${COMEINURL}/irmcenter/anonymous/irstore/${id}/leaveWord`, // 新增留言
	getLeaveWordConfig: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/leaveWord/config`, //留言配置
	getLeaveWordConfigV2: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/leaveWord/config/v2`, //留言配置
	getStockDividendPlan: fullCode => `${COMEINURL}/irmcenter/anonymous/irstore/${fullCode}/stock/dividend-plan`,
	getStockMorthSouthFunds: fullCode => `${COMEINURL}/irmcenter/anonymous/irstore/${fullCode}/stock/north-south-funds`,
	getStockMarginFunds: fullCode => `${COMEINURL}/irmcenter/anonymous/irstore/${fullCode}/stock/margin-funds`,
	getStockFundHolding: fullCode => `${COMEINURL}/irmcenter/anonymous/irstore/${fullCode}/stock/fund-holding`,
	getStockFundHoldingPage: fullCode => `${COMEINURL}/irmcenter/anonymous/irstore/${fullCode}/stock/fund-holding/page`,
	postReportDetail: `${COMEINURL}/irmcenter/anonymous/irstore/research-report-detail`, //研报详情
	getFinancialStatement: fullCode => `${COMEINURL}/irmcenter/anonymous/irstore/${fullCode}/stock/financial-statement`,
	getProfitStatement: fullCode => `${COMEINURL}/irmcenter/anonymous/irstore/${fullCode}/stock/profit-statement`,
	getBalanceSheet: fullCode => `${COMEINURL}/irmcenter/anonymous/irstore/${fullCode}/stock/balance-sheet/sum`,
	getCashFlowStatement: fullCode => `${COMEINURL}/irmcenter/anonymous/irstore/${fullCode}/stock/cash-flow-statement`,
	getMain: (marketType, code) => `${COMEINURL}/irmcenter/anonymous/irstore/${marketType}/${code}/main/indicators`,
	getLiabilities: (marketType, code) =>
		`${COMEINURL}/irmcenter/anonymous/irstore/${marketType}/${code}/assets/liabilities`,
	getCash: (marketType, code) => `${COMEINURL}/irmcenter/anonymous/irstore/${marketType}/${code}/cash/flow`,
	getProfit: (marketType, code) => `${COMEINURL}/irmcenter/anonymous/irstore/${marketType}/${code}/profit`,
	getDividendPlanSummary: fullCode =>
		`${COMEINURL}/irmcenter/anonymous/irstore/${fullCode}/stock/dividend-plan/summary`,
	getShareholderList: (market, code) =>
		`${COMEINURL}/irmcenter/anonymous/irstore/market/${market}/code/${code}/shareholder/number-of-accounts`, // 企业号股东户数
	getInstitutionHoldingsDate: (market, code) =>
		`${COMEINURL}/irmcenter/anonymous/irstore/market/${market}/code/${code}/shareholder/institution-holdings-date`, // 企业号机构持股 - 日期
	getInstitutionHoldings: (market, code) =>
		`${COMEINURL}/irmcenter/anonymous/irstore/market/${market}/code/${code}/shareholder/institution-holdings/v2`, // 企业号机构持股
	getPreInstitutionHoldings: (market, code) =>
		`${COMEINURL}/irmcenter/anonymous/irstore/market/${market}/code/${code}/shareholder/institution-holdings`, // 企业号机构持股(旧版H5)
	getTopTenHoldings: (market, code) =>
		`${COMEINURL}/irmcenter/anonymous/irstore/market/${market}/code/${code}/shareholder/top-ten-holdings/v2`, // 企业号十大股东
	getTopTenHoldingsDate: (market, code) =>
		`${COMEINURL}/irmcenter/anonymous/irstore/market/${market}/code/${code}/shareholder/top-ten-holdings-date`, // 企业号十大股东 - 日期
	getCompanyInfo: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/company`,
	getModulesTabList: (storeId, pageId, moduleId) =>
		`${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/page/${pageId}/customPageTab/${moduleId}`,
	getQuickConfig: (storeId, pageId) =>
		`${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/page/${pageId}/quickLink/config`,
	apiPostScheduleList: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/customs/calendar/schedule/v2`,
	getScheduleLatestThree: storeId =>
		`${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/customs/calendar/schedule/top-three/v2`,

	getSurveyInfo: (storeId, type) =>
		`${COMEINURL}/irmcenter/anonymous/irstore/conference/template/${storeId}/baseInfo/by/${type}`,
	applySurveyRecord: conferenceTemplateId =>
		`${COMEINURL}/irmcenter/anonymous/irstore/appointment/research/${conferenceTemplateId}/apply`,
	// 获取可选时间点 http://yapi.comein.cn/project/56/interface/api/50153
	getOptionalTime: conferenceTemplateId =>
		`${COMEINURL}/irmcenter/anonymous/irstore/appointment/research/${conferenceTemplateId}/optionalDate`,
	// 预约调研-随行人员 http://yapi.comein.cn/project/56/interface/api/50150
	getInvitationMemberList: `${IRMURL}/irm/invitation/card/entourage/info/list`,
	//获取新闻详情
	getNewsDetails: (storeId, newsId) => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/news/${newsId}`,
	getDisplayModule: (storeId, pageId, moduleId) =>
		`${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/page/${pageId}/displayModule/${moduleId}`,
	getPreviewDisplayModule: (storeId, pageId, moduleId) =>
		`${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/page/${pageId}/displayModule/preview/${moduleId}`,
	getESGData: fullCode => `${COMEINURL}/irmcenter/anonymous/irstore/${fullCode}/esg`,
	getAnalystData: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/analyst`,
	getCorporateData: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/corporate`,

	getKLineData: (fullCode, t) => `${COMEINURL}/irmcenter/anonymous/irstore/${fullCode}/stock/candlestick-chart/${t}`,

	getBannerList: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/publish-banners`, // 运营卡片
	tranModuleIds: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/module/tran`, // 模块翻译列表

	// 投关总结
	getIrMarketingDetail: `${COMEINURL}/irmcenter/open/irm/ir-marketing/detail`,
	getAnnouncementLink: `${COMEINURL}/personal/personal/irm/announcement-link/list`,
	// 地区区号按首字母划分
	initialsAreaCode: `${COMEINURL}/platform/json/tools/area-sort-letter`,

	// 消息订阅
	createMessageContact: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/message-contact`,
	getMessageMailCode: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/message-contact/auth-code`,

	getUsAnnouncementType: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/us-announcement-type`,
	getUsAnnouncements: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/us-announcements`,

	rebuild: {
		queryModuleIdWithPageId: (storeId, pageId) =>
			`${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/store-template/page/${pageId}`,
		queryTemplateConfig: (storeId, tmplId) =>
			`${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/store-template/${tmplId}`,
		queryPageListWithTemplateId: (storeId, tmplId) =>
			`${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/store-template/${tmplId}/page-list`
	},
	saveScreenshotImage: `${COMEINURL}/irmcenter/irstore/store-template/save-image`,
	getMessageEvent: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/message-event`,
	getMessageContactConfig: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/message-contact/config`,
	getMessageContactConfigV2: storeId =>
		`${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/message-contact/config/v2`,
	getShareholderMeeting: fullCode => `${COMEINURL}/irmcenter/anonymous/irstore/${fullCode}/hold-meeting`,
	getAnalystDataSide: storeId => `${COMEINURL}/irmcenter/anonymous/irstore/${storeId}/analyst/side`
};
